<template>
  <v-select :placeholder="$t(plkparams.placeholder)" :taggable="plkparams.taggable" :disabled="loading" :loading="loading" class="plk-basic-filter" :multiple="plkparams.multiple" v-model="selected" :options="values" label="value">
    <template #header>
      <div class="title">{{plkparams.title}}</div>
    </template>
    <template #list-header>
      <li @click="clearAll()" class="clearall" v-if="selected.length">{{$t('plk.basicfilter.clearAll')}}</li>
    </template>
    <template #spinner="{ loading }">
      <div v-if="loading" class="vs__spinner loader"></div>
    </template>
    <template #no-options>
      <div v-if="plkparams.taggable && !selected.length">{{$t('plk.basicfilter.taggable')}}</div>
      <div v-if="!plkparams.taggable && !selected.length">{{$t('plk.basicfilter.notOptions')}}</div>
    </template>
  </v-select>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import services from '@/services'
import configuration from './package.json'
import readme from './README.md'
import 'vue-select/dist/vue-select.css'
import { PLAKA } from '@/store'
import BasicComponentMixin from '@/mixins/component'
export const TYPE = services.component.normalizeType('BasicFilter')

export default {
  name: TYPE,
  mixins: [
    BasicComponentMixin
  ],
  data () {
    return {
      selected: undefined,
      dimensionValue: [],
      loading: false,
      externalFilters: false
    }
  },
  components: {
    'v-select': vSelect
  },
  computed: {
    options () {
      return this.plkparams.options || {}
    },
    values () {
      return (this.options.list || []).concat(this.dimensionValue)
    },
    filters () {
      if (this.connectionStarted && this.options.dimension && this.$store.getters[PLAKA.GETTERS.GET_FILTERS]([this.options.dimension.idElement]).length) {
        return this.$store.getters[PLAKA.GETTERS.GET_FILTERS]([this.options.dimension.idElement])[0].values.map(e => ({ filter: e, value: e }))
      } else {
        return []
      }
    }
  },
  methods: {
    getPackage () {
      return configuration
    },
    getReadme () {
      return readme
    },
    clearAll () {
      this.clearFilter(this.options.dimension)
    },
    onFilter (filters) {
      const filterArr = (Array.isArray(filters) ? filters : [filters])
      if (!filters || !filterArr.length) {
        this.clearAll()
      } else {
        let dimension = Object.assign({}, this.options.dimension)
        dimension.values = filterArr.map(f => f.filter === undefined && f.value === undefined ? f : f.filter === undefined ? f.value : f.filter).flat()
        this.getConnection().applyFilters([dimension], { overwrite: true })
      }
    },
    async startData () {
      if (this.getConnection() && this.options.dimension && this.options.loadDimensionValues !== false && !this.plkparams.taggable) {
        Vue.set(this, 'loading', true)
        let values = await this.getConnection().getColumnValues(this.options.dimension)
        if (values && values.data && values.data.dimension && values.data.dimension[this.options.dimension.idElement]) {
          Vue.set(this, 'dimensionValue', (values.data.dimension[this.options.dimension.idElement].index || []).map(e => ({ filter: `${e.id}`, value: e.id })))
          Vue.set(this, 'loading', false)
        }
      } else {
        Vue.set(this, 'loading', false)
      }
    }
  },
  watch: {
    connectionStarted () {
      if (this.connectionStarted && this.getConnection().type === this.$servicesPLK.connection.TYPE.PLAKA) {
        this.startData()
      }
    },
    selected (filters) {
      if (!this.externalFilters) {
        this.onFilter(filters)
      } else {
        Vue.set(this, 'externalFilters', false)
      }
    },
    filters () {
      Vue.set(this, 'externalFilters', true)
      Vue.set(this, 'selected', this.filters)
    }
  }
}
</script>

<style lang="scss">
.plk-basic-filter input,
.plk-basic-filter input:focus {
  height: 25px;
  border: 0px;
}
.plk-basic-filter .vs__selected {
  height: 25px;;
}
.plk-basic-filter .vs__dropdown-toggle {
  min-height: 35px;
}
.plk-basic-filter .vs__deselect {
  height: 0px;
}
.plk-basic-filter .vs__clear {
  margin-top: 0px;
  height: 25px;
}
.plk-basic-filter li {
  margin-bottom: 0rem;
}
.plk-basic-filter li:hover,
.plk-basic-filter li:focus,
.plk-basic-filter li:active,
.plk-basic-filter li:visited,
.plk-basic-filter li:focus-within {
  background: #f0f0f0;
  color: black;
}
.plk-basic-filter .loader {
  border-left-color: grey;
}
.plk-basic-filter .title {
  opacity: .8;
}
.plk-basic-filter .clearall {
  text-align: center;
  cursor: pointer;
}
.vs__actions {
  height: 26px;
}
</style>
